export const capabilities = [
  {
    category: "Technology & Product",
    skills: ["Web development", "React", "TypeScript", "APIs", "Databases", "Systems integration", "Technical architecture", "Custom admin platforms", "Ecommerce systems", "Customer portals", "Automation", "AI-assisted workflows"]
  },
  {
    category: "Marketing & Analytics",
    skills: ["Conversion funnels", "Customer journeys", "Google Analytics", "GTM", "Attribution systems", "Affiliate tracking", "Marketing automation", "Email workflows", "Performance analysis"]
  },
  {
    category: "Business & Operations",
    skills: ["Business development", "Product strategy", "Project leadership", "Vendor selection", "Process design", "Partnership management", "Payment-processing relationships", "Risk/compliance coordination", "Customer-experience design"]
  },
  {
    category: "Leadership & Communication",
    skills: ["Cross-functional leadership", "Technical translation", "Stakeholder communication", "Team coordination", "Vendor management", "Relationship management", "Troubleshooting", "Decision-making under uncertainty"]
  }
];
